module.exports = __webpack_public_path__ + "static/media/tile-16.77a19db6.jpg";